<ul class="nav nav-tabs" role="tablist" style="margin-right: 15px; margin-top: 20px">
  <li role="presentation" class="active">
    <a href="#blockSpecifications" aria-controls="blockSpecifications" role="tab" data-toggle="tab">Model</a>
  </li>

  <li role="presentation">
    <a href="#constraints" aria-controls="constraints" role="tab" data-toggle="tab">Constraints</a>
  </li>

  <li role="presentation">
    <a href="#waterBoilerComments" aria-controls="waterBoilerComments" role="tab" data-toggle="tab">
      <i class="fa fa-comments fa-lg {{ this.unitOperation.comments ? 'gentle-hover-shake' : '' }}" aria-hidden="true">
      </i>
      Comments
    </a>
  </li>
</ul>

<div class="tab-content pw-margin tab-content-padding" [formGroup]="propertyWindowFormGroup">
  <div role="tabpanel" class="tab-pane fade in active" id="blockSpecifications">
    <div class="tab-content no-padding no-border">
      <div class="form-horizontal">
        <div class="form-horizontal" (keyup)="grayOutFields()">
          <h4 class="subtitle">Conditions</h4>
          <hr />
          <br />

          <ng-container>
            <div class="form-group" formGroupName="outletVaporFraction">
              <label class="control-label col-sm-4"> Quality </label>

              <div class="col-sm-8" sobReactiveSimVarInput>
                <div class="row">
                  <div class="col-xs-6">
                    <sob-reactive-unit-select
                      formControlName="unit"
                      [quantity]="unitOperation.outletVaporFraction.quantity">
                    </sob-reactive-unit-select>
                  </div>
                  <div class="col-xs-6">
                    <sob-reactive-variable-value-input
                      formControlName="value"
                      [valueMetaData]="unitOperation.outletVaporFraction">
                    </sob-reactive-variable-value-input>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group" formGroupName="outletTemperature">
              <label class="control-label col-sm-4"> Temperature </label>

              <div class="col-sm-8" sobReactiveSimVarInput>
                <div class="row">
                  <div class="col-xs-6">
                    <sob-reactive-unit-select
                      formControlName="unit"
                      [quantity]="unitOperation.outletTemperature.quantity">
                    </sob-reactive-unit-select>
                  </div>
                  <div class="col-xs-6">
                    <sob-reactive-variable-value-input
                      formControlName="value"
                      [valueMetaData]="unitOperation.outletTemperature">
                    </sob-reactive-variable-value-input>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group" formGroupName="outletPressure">
              <label class="control-label col-sm-4"> Pressure </label>

              <div class="col-sm-8" sobReactiveSimVarInput>
                <div class="row">
                  <div class="col-xs-6">
                    <sob-reactive-unit-select formControlName="unit" [quantity]="unitOperation.outletPressure.quantity">
                    </sob-reactive-unit-select>
                  </div>
                  <div class="col-xs-6">
                    <sob-reactive-variable-value-input
                      formControlName="value"
                      [valueMetaData]="unitOperation.outletPressure">
                      >
                    </sob-reactive-variable-value-input>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group" formGroupName="power">
              <label class="control-label col-sm-4"> Duty </label>

              <div class="col-sm-8" sobReactiveSimVarInput>
                <div class="row">
                  <div class="col-xs-6">
                    <sob-reactive-unit-select formControlName="unit" [quantity]="unitOperation.power.quantity">
                    </sob-reactive-unit-select>
                  </div>
                  <div class="col-xs-6">
                    <sob-reactive-variable-value-input formControlName="value" [valueMetaData]="unitOperation.power">
                      >
                    </sob-reactive-variable-value-input>
                  </div>
                </div>
              </div>
            </div>

            <h4 class="subtitle">GHG</h4>
            <hr />
            <br />

            <div class="form-group" formGroupName="fuelGasEmissionFactor">
              <label class="control-label col-sm-4"> Fuel Gas Emission Factor </label>

              <div class="col-sm-8" sobReactiveSimVarInput>
                <div class="row">
                  <div class="col-xs-6">
                    <sob-reactive-unit-select
                      formControlName="unit"
                      [quantity]="unitOperation.fuelGasEmissionFactor.quantity">
                    </sob-reactive-unit-select>
                  </div>
                  <div class="col-xs-6">
                    <sob-reactive-variable-value-input
                      formControlName="value"
                      [valueMetaData]="unitOperation.fuelGasEmissionFactor">
                    </sob-reactive-variable-value-input>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group" formGroupName="fuelGasHeatingValue">
              <label class="control-label col-sm-4"> Fuel Gas Heating Value (LHV) </label>

              <div class="col-sm-8" sobReactiveSimVarInput>
                <div class="row">
                  <div class="col-xs-6">
                    <sob-reactive-unit-select
                      formControlName="unit"
                      [quantity]="unitOperation.fuelGasHeatingValue.quantity">
                    </sob-reactive-unit-select>
                  </div>
                  <div class="col-xs-6">
                    <sob-reactive-variable-value-input
                      formControlName="value"
                      [valueMetaData]="unitOperation.fuelGasHeatingValue">
                    </sob-reactive-variable-value-input>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group" formGroupName="ghgEmissions">
              <label class="control-label col-sm-4"> GHG Emissions </label>
              <div class="col-sm-8" sobReactiveSimVarInput>
                <div class="row">
                  <div class="col-xs-6">
                    <sob-reactive-unit-select formControlName="unit" [quantity]="unitOperation.ghgEmissions.quantity">
                    </sob-reactive-unit-select>
                  </div>
                  <div class="col-xs-6">
                    <sob-reactive-variable-value-input
                      formControlName="value"
                      [valueMetaData]="unitOperation.ghgEmissions">
                    </sob-reactive-variable-value-input>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <div role="tabpanel" class="tab-pane fade in" id="constraints">
    <p style="text-align: right; position: relative">
      <span style="position: absolute; right: -20px; top: -20px; font-weight: bold">Active</span>
    </p>
    <div class="form-horizontal">
      <ng-container>
        <div class="form-group" formGroupName="massCapacity">
          <label class="control-label col-sm-4"> Maximum Feed Capacity </label>

          <div class="col-sm-8" sobReactiveSimVarInput>
            <div class="row">
              <div class="col-xs-5">
                <sob-reactive-unit-select formControlName="unit" [quantity]="unitOperation.massCapacity.quantity">
                </sob-reactive-unit-select>
              </div>
              <div class="col-xs-5">
                <sob-reactive-variable-value-input formControlName="value" [valueMetaData]="unitOperation.massCapacity">
                </sob-reactive-variable-value-input>
              </div>
              <div class="col-xs-2">
                <sob-reactive-constraint-check-box
                  formControlName="isActive"
                  [isConstraint]="true"
                  [valueMetaData]="unitOperation.massCapacity"></sob-reactive-constraint-check-box>
              </div>
            </div>
          </div>
        </div>

        <div class="form-group" formGroupName="minimumMassFlowrate">
          <label class="control-label col-sm-4"> Minimum Mass Flowrate </label>

          <div class="col-sm-8" sobReactiveSimVarInput>
            <div class="row">
              <div class="col-xs-5">
                <sob-reactive-unit-select
                  formControlName="unit"
                  [quantity]="unitOperation.minimumMassFlowrate.quantity">
                </sob-reactive-unit-select>
              </div>
              <div class="col-xs-5">
                <sob-reactive-variable-value-input
                  formControlName="value"
                  [valueMetaData]="unitOperation.minimumMassFlowrate">
                </sob-reactive-variable-value-input>
              </div>
              <div class="col-xs-2">
                <sob-reactive-constraint-check-box
                  formControlName="isActive"
                  [isConstraint]="true"
                  [valueMetaData]="unitOperation.minimumMassFlowrate"></sob-reactive-constraint-check-box>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <div role="tabpanel" class="tab-pane fade in" id="waterBoilerComments">
    <div class="tab-content no-padding no-border">
      <sob-unit-operation-comments [unitOpId]="this.unitOperation.id"></sob-unit-operation-comments>
    </div>
  </div>
</div>
